import React from 'react';

const AfterHours = () => {
  return (
    <div className="w-full max-w-2xl mx-auto p-6 bg-white rounded-lg shadow">
      <h2 className="text-3xl font-bold mb-4 text-gray-800 text-center">
        After Office Hours
      </h2>
      <p className="text-gray-700 mb-4">
        We understand that illness can occur outside of regular office hours. For urgent medical advice during these times, please call our pager.
      </p>

      <h3 className="text-xl font-semibold mb-2 text-gray-800">
        Paging Instructions:
      </h3>
      <ol className="list-decimal list-outside ml-5 mb-4 text-gray-700 space-y-2">
        <li>Dial <span className="font-bold">(309) 646-2251</span></li>
        <li>Listen to the greeting message</li>
        <li>After the beep, enter your area code and phone number</li>
        <li>Hang up</li>
        <li>The doctor will return your call as soon as possible</li>
        <li>If necessary, you may page the doctor again</li>
      </ol>

      <p className="text-gray-700 mb-4">
        Alternatively, you may send a text message to the doctor on call by visiting
        {' '}
        <a
          href="https://www.usamobility.net/message/index.html"
          target="_blank"
          rel="noopener noreferrer"
          className="text-blue-600 underline"
        >
          https://www.usamobility.net/message/index.html
        </a>. 
      </p>

      <ol className="list-decimal list-outside ml-5 mb-4 text-gray-700 space-y-2">
        <li>
          Enter the pager number <span className="font-bold">(309-646-2251)</span> and click "Continue"
        </li>
        <li>On the next page, input your message</li>
        <li>Include your contact information</li>
        <li>The on-call doctor will contact you as soon as possible</li>
      </ol>

      <p className="text-gray-700 mb-4">
        A physician will return your call as soon as possible to assess the situation and determine the appropriate course of action. Please note that phone consultations are a courtesy service provided by the doctors.
      </p>
    </div>
  );
};

export default AfterHours;
